var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sg-link',{staticClass:"social-login-btn social-btn",attrs:{"to":_vm.buildUrl('/auth/' + _vm.provider).toString()}},[_c('img',{staticClass:"social-icon",attrs:{"src":`/images/icons/${_vm.provider}.svg`,"alt":`${_vm.provider}`}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }